import { GlobalService } from '../../../services/global.service';
import { ErrorEventArgs } from '../../../models/event-args/global-error.event.args';
import { ssApiService } from '../../../services/ss-api.service';
import { Subscription } from 'rxjs';
import { KeyValuePair, KeyValuePairArray } from '../../../models/KeyValuePair';
import { HttpError } from '../../../models/errors/HttpError';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SendTwoFactorCodeOptionRequest, CommTypes } from '../../../models/ss-api/requests/send.two.factor.code.option.request';

@Component({
    selector: 'twofactor-choice',
    templateUrl: './twofactor-choice-form.component.html',
})
export class TwoFactorChoiceFormComponent implements OnInit {

    // inputs
    @Input('TwoFactorOptions') TwoFactorOptions: KeyValuePairArray<string, string>;

    // outputs
    @Output('onBusyChanged') onBusyChanged = new EventEmitter<Boolean>();
    @Output('onError') onError = new EventEmitter<ErrorEventArgs>();
    @Output('onCodeSent') onCodeSent = new EventEmitter<string>();
    @Output('onCancel') onCancel = new EventEmitter();

    // public
    public SelectedOption: KeyValuePair<string, string>;

    // private
    private showTimeout: boolean = true;

    constructor(private api: ssApiService, private gb: GlobalService) {
    }

    ngOnInit() {

    }

    Cancel() {
        this.onCancel.emit();
    }

    private ResetSigninFormSubmitRequest(request: Subscription) {
        request.unsubscribe();
        this.showTimeout = false;
        this.onBusyChanged.emit(false);
    }

    async CodeRequestSubmit() {


        this.onBusyChanged.emit(true);

        if (this.SelectedOption == undefined)
            this.SelectedOption = this.TwoFactorOptions[0];

        let data = new SendTwoFactorCodeOptionRequest();     

        if (this.SelectedOption.Key == 'GOOGLE') 
        {            
            this.onCodeSent.emit("GOOGLE");
            return;
        } 
        else if (this.SelectedOption.Key == 'EMAIL') 
        {
            data.CommType = CommTypes.Email;
        } 
        else if (this.SelectedOption.Key = 'SMS') 
        {
            data.CommType = CommTypes.SMS;
        }

        data.CommValue = this.SelectedOption.Value;
        data.Token = this.gb.Token;


        let request = this.api.SendTwoFactorCode(data)
            .subscribe(response => {
                this.ResetSigninFormSubmitRequest(request);

                if (!response.Result) {
                    // error
                    this.onError.emit(new ErrorEventArgs('0', response.Message, response.Message, 'Error'));
                    return;
                }


                this.onCodeSent.emit(response.Data);
            },


            (error: HttpError) => {
                this.ResetSigninFormSubmitRequest(request);

                this.onError.emit(new ErrorEventArgs('0', error.OriginalError, error.FriendlyMessage, error.FriendlyTitle));
            }
        );


        // set timeout
       // this.showTimeout = true;

       // setTimeout(() => {

         //   this.ResetSigninFormSubmitRequest(request);

        //    if (this.showTimeout)
          //      this.onError.emit(new ErrorEventArgs('0', 'timeout', 'Error connecting to server. Please try again later.', 'Timeout Error'));

       // }, this.gb.HttpTimeout);

    }



}
